module.exports = __webpack_public_path__ + "img/success.adc7d794.png";